export const ENDPOINT = {
  AUTH: {
    triggerOTP: 'api/jarvis/otp/trigger',
    validateOTP: 'api/jarvis/otp/validate',
    logoutUser: 'api/jarvis/logout',
  },
  CREDIT_REPORT: {
    getCreditScore: 'api/jarvis/creditscore/{userNumber}',
    getCreditScorePan: 'api/jarvis/creditscore/{userNumber}/masked',
    authenticateMaskedMobile:
      'api/jarvis/creditscore/{userNumber}/authenticate',
    consentRevoke: 'api/jarvis/user/{userNumber}/consent/revoke',
    leadCapture: 'api/jarvis/lending/lead',
    creditDetails: 'api/jarvis/user',
    bureauData: 'api/jarvis/user/{userNumber}/bureau-data',
  },
  LEADS: {
    generateLead: 'api/jarvis/lending/lead',
    updateLead: 'api/jarvis/lending/lead',
    gstData: 'api/jarvis/user',
    gstInfo: 'api/jarvis/user/gst/validate',
    sendUserInfo: 'api/jarvis/user/gst/save',
  },
  LENDERS: {
    getLendersApi: 'api/jarvis/lending/lenders/eligible',
    uploadDocument: (phone: string) => `api/jarvis/user/${phone}/document`,
    getDocuments: (phone: string) => `api/jarvis/user/${phone}/documents`,
    deleteDocument: (phone: string, docId: number) =>
      `api/jarvis/user/${phone}/document/${docId}`,
    bsaInitiate: (phone: string) =>
      `api/jarvis/user/${phone}/document/bsa/initiate`,
    bsaStatus: (phone: string) =>
      `api/jarvis/user/${phone}/document/bsa/status`,
  },
  THIRD_PARTY: {
    hyperVergeKycValidate: (phone: string) =>
      `api/jarvis/user/${phone}/kyc/validate`,
    hyperVergeKycToken: (phone: string) => `api/jarvis/user/${phone}/kyc/token`,
    checkHyperverge: (phone: string) => `/api/jarvis/user/${phone}/kyc/status`,
  },
};
